import { render, staticRenderFns } from "./PromptDetail.vue?vue&type=template&id=75a1d546"
import script from "./PromptDetail.vue?vue&type=script&lang=js"
export * from "./PromptDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports